var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      {
        staticClass: "title text-dark",
        on: {
          click: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.showDetail()
          }
        }
      },
      [_vm._v(_vm._s(_vm.productName))]
    ),
    _vm._v(" "),
    _c("a", {
      staticClass: "fa fa-external-link green",
      on: {
        click: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.showDetail()
        }
      }
    }),
    _vm._v(" "),
    _c("a", {
      staticClass: "fa red",
      class: { "fa-heart-o": !_vm.favorited, "fa-heart": _vm.favorited },
      on: {
        click: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.toggleFavorite()
        }
      }
    }),
    _vm._v(" "),
    _vm.isOnSale
      ? _c("img", {
          attrs: {
            src: "/assets/images/sale_icon.svg",
            alt: "On Sale",
            title: "On Sale"
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "brand" }, [_vm._v(_vm._s(_vm.brandName))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }